import produce from 'immer';

import {
  ACTIVE_AGENCIES_FETCH_FAILURE,
  ACTIVE_AGENCIES_FETCH_SUCCESS,
  AGENCIES_FETCH_FAILURE,
  AGENCIES_FETCH_REQUEST,
  AGENCIES_FETCH_SUCCESS,
  AGENCY_CRM_AUTH_EDIT_FAILURE,
  AGENCY_CRM_AUTH_EDIT_SUCCESS,
  AGENCY_CRM_AUTH_FETCH_FAILURE,
  AGENCY_CRM_AUTH_FETCH_SUCCESS,
  AGENCY_DELETE_FAILURE,
  AGENCY_DELETE_REQUEST,
  AGENCY_DELETE_SUCCESS,
  AGENCY_FETCH_FAILURE,
  AGENCY_FETCH_REQUEST,
  AGENCY_FETCH_SUCCESS,
  AGENCY_INFO_EDIT_FAILURE,
  AGENCY_INFO_EDIT_SUCCESS,
  AGENCY_INFO_FETCH_FAILURE,
  AGENCY_INFO_FETCH_SUCCESS,
  AGENCY_PRODUCT_CONFIGS_EDIT_FAILURE,
  AGENCY_PRODUCT_CONFIGS_EDIT_REQUEST,
  AGENCY_PRODUCT_CONFIGS_EDIT_SUCCESS,
  AGENCY_PRODUCT_CONFIGS_FETCH_FAILURE,
  AGENCY_PRODUCT_CONFIGS_FETCH_REQUEST,
  AGENCY_PRODUCT_CONFIGS_FETCH_SUCCESS,
  AGENCY_SETTINGS_EDIT_FAILURE,
  AGENCY_SETTINGS_EDIT_SUCCESS,
  AGENCY_SETTINGS_FETCH_FAILURE,
  AGENCY_SETTINGS_FETCH_REQUEST,
  AGENCY_SETTINGS_FETCH_SUCCESS,
  CITIZEN_PORTAL_CONFIG_FETCH_FAILURE,
  CITIZEN_PORTAL_CONFIG_FETCH_REQUEST,
  CITIZEN_PORTAL_CONFIG_FETCH_SUCCESS,
  CITIZEN_PORTAL_CONFIG_SAVE_FAILURE,
  CITIZEN_PORTAL_CONFIG_SAVE_REQUEST,
  CITIZEN_PORTAL_CONFIG_SAVE_SUCCESS,
  LOAD_EXT_INTEGRATION_DATA_SUCCESS,
  UBS_CONTACT_ROLES_FETCH_FAILURE,
  UBS_CONTACT_ROLES_FETCH_SUCCESS,
} from '@actions/agency';

const initialState: IAgencyStore = {
  currentAgency: null,
  activeAgenciesListing: null,
  agencyInfo: null,
  agencies: null,
  isFetching: false,
  error: null,
  ubsContactRoles: [],
  agencySettings: null,
  productConfigurations: null,
  productConfigurationsAgencyId: null,
  pendingProductConfigurationsAgencyId: null,
  crmAuthentication: null,
  portalConfiguration: null,
};

export default (state: IAgencyStore = initialState, action: any) =>
  produce(state, (draftState: IAgencyStore) => {
    switch (action.type) {
      case AGENCIES_FETCH_REQUEST:
      case AGENCY_DELETE_REQUEST:
      case AGENCY_SETTINGS_FETCH_REQUEST:
      case CITIZEN_PORTAL_CONFIG_FETCH_REQUEST:
      case CITIZEN_PORTAL_CONFIG_SAVE_REQUEST:
        draftState.isFetching = true;
        draftState.error = null;

        return;

      case AGENCIES_FETCH_SUCCESS:
        draftState.isFetching = false;
        draftState.error = null;
        draftState.agencies = action.response;

        return;

      case AGENCIES_FETCH_FAILURE:
        draftState.isFetching = false;
        draftState.error = action.error;
        draftState.agencies = null;

        return;

      case AGENCY_DELETE_SUCCESS:
        draftState.isFetching = false;
        draftState.error = null;

        return;

      case AGENCY_DELETE_FAILURE:
        draftState.isFetching = false;
        draftState.error = action.error;

        return;

      case AGENCY_FETCH_REQUEST:
        draftState.isFetching = true;
        draftState.currentAgency = null;

        return;

      case AGENCY_FETCH_SUCCESS:
        draftState.isFetching = false;
        draftState.error = null;
        draftState.currentAgency = action.response;

        return;

      case AGENCY_FETCH_FAILURE:
        draftState.isFetching = false;
        draftState.error = action.error;
        draftState.currentAgency = null;

        return;

      case AGENCY_INFO_FETCH_SUCCESS:
      case AGENCY_INFO_EDIT_SUCCESS:
        draftState.isFetching = false;
        draftState.error = null;
        draftState.agencyInfo = action.response;

        return;

      case AGENCY_INFO_FETCH_FAILURE:
        draftState.isFetching = false;
        draftState.error = action.error;
        draftState.agencyInfo = null;

        return;

      case AGENCY_INFO_EDIT_FAILURE:
        draftState.isFetching = false;
        draftState.error = action.error;

        return;

      case ACTIVE_AGENCIES_FETCH_SUCCESS:
        draftState.isFetching = false;
        draftState.error = null;
        draftState.activeAgenciesListing = action.response;

        return;

      case ACTIVE_AGENCIES_FETCH_FAILURE:
        draftState.isFetching = false;
        draftState.error = action.error;
        draftState.activeAgenciesListing = null;

        return;

      case UBS_CONTACT_ROLES_FETCH_SUCCESS:
        draftState.isFetching = false;
        draftState.ubsContactRoles = action.response;

        return;

      case UBS_CONTACT_ROLES_FETCH_FAILURE:
        draftState.isFetching = false;
        draftState.error = action.error;
        draftState.ubsContactRoles = [];

        return;

      case LOAD_EXT_INTEGRATION_DATA_SUCCESS:
        const { integrationSource } = action.response;
        draftState.currentAgency = {
          ...draftState.currentAgency,
          integrations: {
            ...draftState.currentAgency.integrations,
            ...(integrationSource === ExternalIntegrationSource.CARTEGRAPH
              ? {
                  configCartegraph: {
                    ...draftState.currentAgency.integrations.configCartegraph,
                    dataLoadStatus: DataLoadStatus.IN_PROGRESS,
                  },
                }
              : {}),
            ...(integrationSource === ExternalIntegrationSource.LUCITY
              ? {
                  configLucity: {
                    ...draftState.currentAgency.integrations.configLucity,
                    dataLoadStatus: DataLoadStatus.IN_PROGRESS,
                  },
                }
              : {}),
          },
        };

        return;

      case AGENCY_SETTINGS_FETCH_SUCCESS:
      case AGENCY_SETTINGS_EDIT_SUCCESS:
        draftState.isFetching = false;
        draftState.error = null;
        draftState.agencySettings = action.response;

        return;

      // Leaves isFetching alone: EditAgency unmounts its tabs while it is true, which would
      // reset the Admin agency page to its first tab whenever product configs load or save.
      case AGENCY_PRODUCT_CONFIGS_FETCH_REQUEST:
      case AGENCY_PRODUCT_CONFIGS_EDIT_REQUEST:
        draftState.error = null;

        if (action.agencyId != null) {
          draftState.pendingProductConfigurationsAgencyId = action.agencyId;

          if (draftState.productConfigurationsAgencyId !== action.agencyId) {
            draftState.productConfigurationsAgencyId = null;
          }
        }

        return;

      case AGENCY_PRODUCT_CONFIGS_FETCH_SUCCESS:
      case AGENCY_PRODUCT_CONFIGS_EDIT_SUCCESS:
        draftState.isFetching = false;
        draftState.error = null;

        if (action.agencyId == null || action.agencyId === draftState.pendingProductConfigurationsAgencyId) {
          draftState.productConfigurations = action.response;
          draftState.productConfigurationsAgencyId = action.agencyId ?? null;
        }

        return;

      case AGENCY_CRM_AUTH_FETCH_SUCCESS:
      case AGENCY_CRM_AUTH_EDIT_SUCCESS:
        draftState.isFetching = false;
        draftState.error = null;
        draftState.crmAuthentication = action.response;

        return;

      case CITIZEN_PORTAL_CONFIG_FETCH_SUCCESS:
      case CITIZEN_PORTAL_CONFIG_SAVE_SUCCESS:
        draftState.isFetching = false;
        draftState.error = null;
        draftState.portalConfiguration = action.response;

        return;

      case AGENCY_SETTINGS_FETCH_FAILURE:
        draftState.isFetching = false;
        draftState.error = action.error;
        draftState.agencySettings = null;

        return;

      case AGENCY_PRODUCT_CONFIGS_FETCH_FAILURE:
        draftState.isFetching = false;
        draftState.error = action.error;

        if (action.agencyId == null || action.agencyId === draftState.pendingProductConfigurationsAgencyId) {
          draftState.productConfigurations = null;
          draftState.productConfigurationsAgencyId = null;
        }

        return;

      case AGENCY_CRM_AUTH_FETCH_FAILURE:
        draftState.isFetching = false;
        draftState.error = action.error;
        draftState.crmAuthentication = null;

        return;

      case CITIZEN_PORTAL_CONFIG_FETCH_FAILURE:
      case CITIZEN_PORTAL_CONFIG_SAVE_FAILURE:
        draftState.isFetching = false;
        draftState.error = action.error;

        return;

      case AGENCY_SETTINGS_EDIT_FAILURE:
      case AGENCY_PRODUCT_CONFIGS_EDIT_FAILURE:
      case AGENCY_CRM_AUTH_EDIT_FAILURE:
        draftState.isFetching = false;
        draftState.error = action.error;

        return;
    }
  });
